import { z } from 'zod';
import { brandChannelKindSchema } from './brand-channel.js';
// mag-channel-proposer — spec §0b.7. Output schema for the proposer
// agent that watches for signals the brand should be on a channel
// it isn't yet (or should resume one it paused). Lands as a feed_card
// with kind='mag_channel_proposal'; accept → upsert brand_channels
// with operatedByMag=true, dismiss → trust signal.
export const magChannelProposerProposalSchema = z.object({
    channelKind: brandChannelKindSchema,
    /** Mag-voice rationale — 2-3 sentences citing the signal she
     *  read off (site footer, founder mention, competitor pattern,
     *  etc.). Lowercase. */
    rationale: z.string().min(40).max(800),
    /** Copy that lands in the feed card body — the founder reads this
     *  before accepting. 3-5 sentences, mag voice. Names what mag would
     *  do once the connection is live (e.g. "i'd start with 2 posts/wk,
     *  founder-pov pillar, and learn from the first 4 weeks before
     *  expanding format mix"). */
    bodyForFounder: z.string().min(40).max(1200),
    /** One-line proposed cadence the founder can grok at-a-glance.
     *  ("2 posts/week + 1 carousel" / "weekly long-form + monthly
     *  interview cut"). The brand-content-plan agent owns the actual
     *  cadence on accept; this is just the proposal hook. */
    proposedCadence: z.string().min(1).max(200),
    /** What mag would need from the founder to start. 0-3 lines —
     *  usually a connection handoff + maybe permissions. */
    founderHandoff: z.array(z.string().min(1).max(200)).max(3),
    /** Mag's confidence, 0-10. Low when she's reaching on thin signal;
     *  high when the founder asked or the brand obviously needs it. */
    confidence: z.number().int().min(0).max(10),
});
export const magChannelProposerOutputSchema = z.discriminatedUnion('decision', [
    z.object({
        decision: z.literal('propose'),
        proposal: magChannelProposerProposalSchema,
    }),
    z.object({
        decision: z.literal('no_signal'),
        noSignalReason: z.string().min(1).max(280),
    }),
]);
export const magChannelProposalCardPayloadSchema = z.object({
    kind: z.literal('mag_channel_proposal'),
    proposal: magChannelProposerProposalSchema,
    generatedAt: z.string().datetime(),
    costUsd: z.number().min(0),
});
//# sourceMappingURL=mag-channel-proposer.js.map